import { useQuery } from '~/utils/rq';

export type ForcedExposureCreative = {
  id: string;
  file_name: string;
  display_name: string;
  exposure_type: string;
  exposure_device: string;
  updated_at: string;
};

export type ForcedExposureCreativeResponseType = {
  items: ForcedExposureCreative[];
};

export const useFetchForcedExposureCreatives = (
  campaignId?: string,
  isEnabled = true
) => {
  const URL = `admin/campaigns/${campaignId}/forced-exposure/creatives`;

  return useQuery<ForcedExposureCreativeResponseType>(
    {
      queryKey: [URL],
      staleTime: 10 * 60 * 60,
      enabled: !!campaignId && isEnabled
    },
    {
      method: 'get',
      url: URL
    }
  );
};

export type ForcedExposureCreativeDownloadResponseType = {
  id: string;
  campaign_id: string;
  file_name: string;
  display_name: string;
  download_url: string;
  expires_at: string;
};

export const useFetchForcedExposureCreativeDownload = ({
  campaignId,
  creativeId,
  isEnabled = false
}: {
  campaignId?: string;
  creativeId?: string;
  isEnabled?: boolean;
}) => {
  const URL = `admin/campaigns/${campaignId}/forced-exposure/creatives/${creativeId}/download`;

  return useQuery<ForcedExposureCreativeDownloadResponseType>(
    {
      queryKey: [URL],
      staleTime: 10 * 60 * 60,
      enabled: !!campaignId && !!creativeId && isEnabled
    },
    {
      method: 'get',
      url: URL
    }
  );
};
